module.exports = __webpack_public_path__ + "img/male-comment.084884ad.jpg";